export const CART_ADD_ITEM = 'CART_ADD_ITEM'
export const CART_ADD_REQUEST = 'CART_ADD_REQUEST'
export const CART_ADD_FAIL = 'CART_ADD_FAIL'